// TODO: migrate to @raydiant/raydial icon
import { SVGProps } from 'react';

interface CopyIconProps extends SVGProps<SVGSVGElement> {
  size?: number;
}

const CopyIcon = ({ size = 17, ...props }: CopyIconProps) => {
  const width = (size * 15) / 17;
  return (
    <svg
      width={width}
      height={size}
      viewBox="0 0 15 17"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M12.75 11.1562C13.0156 11.1562 13.2812 10.9238 13.2812 10.625V3.85156L11.0234 1.59375H6.375C6.07617 1.59375 5.84375 1.85938 5.84375 2.125V10.625C5.84375 10.9238 6.07617 11.1562 6.375 11.1562H12.75ZM6.375 12.75C5.17969 12.75 4.25 11.8203 4.25 10.625V2.125C4.25 0.962891 5.17969 0 6.375 0H11.0234C11.4219 0 11.8535 0.199219 12.1523 0.498047L14.377 2.72266C14.6758 3.02148 14.875 3.45312 14.875 3.85156V10.625C14.875 11.8203 13.9121 12.75 12.75 12.75H6.375ZM2.125 4.25H3.1875V5.84375H2.125C1.82617 5.84375 1.59375 6.10938 1.59375 6.375V14.875C1.59375 15.1738 1.82617 15.4062 2.125 15.4062H8.5C8.76562 15.4062 9.03125 15.1738 9.03125 14.875V13.8125H10.625V14.875C10.625 16.0703 9.66211 17 8.5 17H2.125C0.929688 17 0 16.0703 0 14.875V6.375C0 5.21289 0.929688 4.25 2.125 4.25Z"
        fill="currentColor"
      />
    </svg>
  );
};

export default CopyIcon;
